
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'

const styles = theme => ({
  row: { // Stripe Table
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    }
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
})

const DesktopSessionListBody = ({ sessions, recallSession, onClickViewProfile, classes, t }) => (
  <TableBody>
    {sessions.map(row => (
      <TableRow 
        key={row.sessionId}
        className={classes.row}
      >
        <TableCell>{row.caseId}</TableCell>
        <TableCell>
          {row.startTime}
          <br />
          {row.endTime || '---'}
        </TableCell>
        <TableCell>{row.isComplete}</TableCell>
        <TableCell>{row.lastScreenSaved.length > 0 ? t('Last Page '+row.lastScreenSaved) : '---'}</TableCell>
        <TableCell>
            <a
              href="#/"
              className={classes.link}
              onClick={() => recallSession(row)}
            >{row.isComplete.toLowerCase() === 'yes' ? t('Results') : t('Last Page')}</a>
          {row.languageCode.toLowerCase() !== 'en' && row.isComplete.toLowerCase() === 'yes' && (
            <Fragment>
              <br />
              <a 
                href="#/"
                className={classes.link}
                onClick={() => recallSession(row, '/session/translation')}
              >{`${t('Translate from')} ${row.languageName}`}</a>
            </Fragment>
          )}
          {row.languageCode.toLowerCase() !== 'en' && row.isComplete.toLowerCase() !== 'yes' && (
            <Fragment>
              <br />
              {`${t('Conducted in')} ${row.languageName}`}
            </Fragment>
          )}
          {row.isComplete.toLowerCase() === 'yes' && (
            <Fragment>
              <br />
              <a 
                href="#/"
                className={classes.link}
                onClick={() => onClickViewProfile(row.sessionId)}
              >
                {t('View Profile')}
              </a>
            </Fragment>
          )}
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
)

DesktopSessionListBody.propTypes = {
  sessions: PropTypes.array,
  recallSession: PropTypes.func
}

export default compose(
  withStyles(styles),
  translate()
)(DesktopSessionListBody)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Desktop/SessionListBody.js